import Box from '@mui/material/Box'
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded'
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded'
import IconButton from '@mui/material/IconButton'
import { makeStyles } from '@mui/styles'
import { isRtl } from '../../../../settings'
import clsx from 'clsx'

const useStyles = makeStyles(() => ({
  navigateButton: {
    position: 'absolute',
    height: 30,
    top: 'calc(50% - 15px)',
    padding: 0,
  },
  next: {
    flip: isRtl,
    right: 0,
  },
  prev: {
    flip: isRtl,
    left: 0,
  },
}))

const CarouselNavigators = ({
  nextImage,
  prevImage,
  isLastImage,
  isFirstImage,
  children,
}) => {
  const classes = useStyles()

  return (
    <Box position="relative">
      <IconButton
        onClick={nextImage}
        disabled={isLastImage}
        className={clsx({
          [classes.navigateButton]: true,
          [classes.next]: true,
        })}
        disableRipple
        size="large"
      >
        <ArrowBackIosRoundedIcon />
      </IconButton>
      <Box px={1}>{children}</Box>
      <IconButton
        disabled={isFirstImage}
        className={clsx({
          [classes.navigateButton]: true,
          [classes.prev]: true,
        })}
        onClick={prevImage}
        disableRipple
        size="large"
      >
        <ArrowForwardIosRoundedIcon />
      </IconButton>
    </Box>
  )
}

export default CarouselNavigators
